import React, { useState, useEffect, useRef } from 'react';
// import Paper from '@material-ui/core/Paper';
// import { 
//   DataGrid, GridToolbarExport, GridToolbarContainer 
// } from '@material-ui/data-grid';
import { makeStyles } from '@material-ui/core/styles';
import { Box, IconButton } from '@material-ui/core';
import { Paper } from '@mui/material';
import { DataGrid, GridToolbarExport, GridToolbarContainer } from '@mui/x-data-grid';
//import { makeStyles } from '@mui/styles';
//import { Box, IconButton } from '@mui/system';

import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from '@material-ui/icons';
import {
  firstDateOfMonth,
  getPrevMonthDay,
  getNextMonthDay,
  getYearMonthKor,
} from '../calendar';
import { reqCashReceipt } from './api';
import { Actions, Resources, useHasPermissions } from '../lib/react-admin-loopback';

const useStyles = makeStyles((theme) => ({
  paper: {
    textAlign: 'center',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
}));

// DataGrid column 설정
const columns = [
  { field: 'id', headerName: 'id', width: 50, hide: true },
  { field: 'invoiceBusinessNo', headerName: '사업자등록번호', width: 170 },
  { field: 'name', headerName: '상품명', width: 130 },
  { field: 'total', headerName: '결제금액', width: 130 },
  { field: 'supply', headerName: '공급가액', width: 130 },
  { field: 'vat', headerName: '부가세', width: 120 },
  { field: 'serviceCharge', headerName: '봉사료', width: 120 },
  { field: 'purchaser', headerName: '구매자명', width: 130 },
  { field: 'invoiceEmail', headerName: 'E-Mail', width: 120 },
  { field: 'etc1', headerName: '주민', width: 120 },
  { field: 'etc2', headerName: '사업자', width: 120 },
  { field: 'etc3', headerName: '핸드폰', width: 120 },
  { field: 'etc4', headerName: '카드번호', width: 120 },
];

const SupplierCashReceiptList = (props) => {

  const hasPermission = useHasPermissions(
    Resources.SupplierBill,
    Actions.List,
    () => {
      alert('권한이 없습니다.');
      props.history.push('/schedules');
    }
  );

    const classes = useStyles();
    const [firstDate, setFirstDate] = useState(firstDateOfMonth(new Date()));
    const dataRef = useRef({
      receiptData: []
    });
  
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          // load 정산 자료
          setLoading(true);
          const { data } = await reqCashReceipt(firstDate);
  
          dataRef.current.receiptData = data;
          console.log(dataRef.current.receiptData);
          setLoading(false);
        } catch (err) {
          setError(err);
          setLoading(false);
          // LATER server logging
          console.error(err);
        }
      };
      fetchData();
    }, [firstDate]);
  
    //이전달
    const handleClickPrev = () => {
      setFirstDate(getPrevMonthDay(firstDate));
    };
  
    // 다음달
    const handleClickNext = () => {
      setFirstDate(getNextMonthDay(firstDate));
    };
    return (
      <div style={{ height: '100%', width: '100%' }}>
        <Paper className={classes.paper}>
          <Box>
            <IconButton aria-label='go to prev' onClick={handleClickPrev}>
              <ChevronLeftIcon />
            </IconButton>
            <span>{getYearMonthKor(firstDate)}</span>
            <IconButton aria-label='go to next' onClick={handleClickNext}>
              <ChevronRightIcon />
            </IconButton>
          </Box>
        </Paper>
        <br />
        <DataGrid
          rows={dataRef.current.receiptData}
          columns={columns}
          pageSize={30}
          components={{
            Toolbar: Toolbar
          }}
          error={error}
          loading={loading}
        />
      </div>
    );
  };
  
  const Toolbar = () => (
    <GridToolbarContainer>
      <GridToolbarExport  
        csvOptions={{fileName: 'CashReceipt', delimiter: '|', utf8WithBom: true, includeHeaders: false}}
        printOptions={{disableToolbarButton: true}}
      />
    </GridToolbarContainer>
  );
  
  export default SupplierCashReceiptList;